// 开发配置

const env = process.env.NODE_ENV;

const Setting = {
  NODE_ENV: 'production', // 项目环境 development / production
  // URL_DEVELOPMENT: "http://192.168.0.91:8086",  // 开发环境地址
  // URL_PRODUCTION: "http://192.168.0.91:8086",  // 生产环境地址
  // URL_DEVELOPMENT_FISCO: "http://192.168.0.91:9512",  // 开发环境地址
  // URL_PRODUCTION_FISCO: "http://192.168.0.91:9512",  // 生产环境地址
  // URL_DEVELOPMENT_NFR: "http://192.168.0.91:30000",  // 开发环境地址
  // URL_PRODUCTION_NFR: "http://192.168.0.91:30000",  // 生产环境地址
  // 以上为测试相关
  URL_DEVELOPMENT: "http://dbpp.dcpay.cn:8086",  // 开发环境地址
  URL_PRODUCTION: "http://dbpp.dcpay.cn:8086",  // 生产环境地址
  URL_DEVELOPMENT_FISCO: "http://dbpp.dcpay.cn:9512",  // 开发环境地址
  URL_PRODUCTION_FISCO: "http://dbpp.dcpay.cn:9512",  // 生产环境地址
  URL_DEVELOPMENT_NFR: "http://dbpp.dcpay.cn:30001",  // 开发环境地址
  URL_PRODUCTION_NFR: "http://dbpp.dcpay.cn:30001",  // 生产环境地址
  // 是否使用 Mock 的数据，
  isMock: false,
  // 部署应用包时的基本 URL
  publicPath: '/',
  // 生产环境构建文件的目录名
  outputDir: 'dist',
  // 放置生成的静态资源 (js、css、img、fonts) 的 (相对于 outputDir 的) 目录。
  assetsDir: '',
  // 开发环境每次保存时 lint 代码，会将 lint 错误输出为编译警告
  // true || false || error
  lintOnSave: false,
  // iView Loader 的选项
  // 详见 https://www.iviewui.com/docs/guide/iview-loader
  iviewLoaderOptions: {
    prefix: false
  },
  // UPLOAD_API_URL: "http://192.168.0.91:8086",  // 文件上传地址
  UPLOAD_API_URL: "http://dbpp.dcpay.cn:20005",  // 文件上传地址
  // MonitorUrl: "http://192.168.0.93:9000/#!/home",  // 监控平台地址
  MonitorUrl: "http://dbpp.dcpay.cn:20003",  // 监控平台地址
};

module.exports = Setting;
